import { render, staticRenderFns } from "./ProdutosPorMarca.vue?vue&type=template&id=a96feac4&scoped=true&"
import script from "./ProdutosPorMarca.vue?vue&type=script&lang=js&"
export * from "./ProdutosPorMarca.vue?vue&type=script&lang=js&"
import style0 from "./ProdutosPorMarca.vue?vue&type=style&index=0&id=a96feac4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96feac4",
  null
  
)

export default component.exports